import { Validator } from '@vista-digital/validator';
/**
 * The type of the barcode.
 */
export var BarcodeType;
(function (BarcodeType) {
    /**
     * One dimensional barcode using the Code128 type.
     */
    BarcodeType["Code128"] = "Code128";
    /**
     * Two dimensional barcode using the QRCode type.
     */
    BarcodeType["QrCode"] = "QrCode";
})(BarcodeType || (BarcodeType = {}));
export const barcodeTypeValidator = Validator.oneOf(Object.values(BarcodeType));
